import { render, staticRenderFns } from "./IconHistory.vue?vue&type=template&id=b73dfec8"
import script from "./IconHistory.vue?vue&type=script&lang=ts"
export * from "./IconHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports